<template>
  <v-container class="py-3 px-2" fluid v-if="myRun">
    <v-layout wrap>
      <v-flex
        :sm4="myRun.config.coronal_model.Magnetogram.provider !== 'custom'"
        :sm6="myRun.config.coronal_model.Magnetogram.provider === 'custom'"
        class="px-3"
        xs12
      >
        <v-select :items="providers" label="Provider" v-model="myRun.config.coronal_model.Magnetogram.provider"></v-select>
      </v-flex>
      <v-flex class="px-3" sm4 v-if="myRun.config.coronal_model.Magnetogram.provider !== 'custom'" xs12>
        <v-dialog full-width persistent ref="dialog-cme-time" v-model="menuDate" width="290px">
          <v-text-field label="Date" readonly slot="activator" v-model="myRun.config.coronal_model.Magnetogram.date"></v-text-field>
          <v-date-picker @input="menuDate=false" scrollable v-model="myRun.config.coronal_model.Magnetogram.date"></v-date-picker>
        </v-dialog>
      </v-flex>
      <v-flex class="px-3" sm4 v-if="myRun.config.coronal_model.Magnetogram.provider !== 'custom'" xs12>
        <v-select
          :item-text="'time'"
          :item-value="'url'"
          :items="externalMagnetograms"
          :loading="$apollo.queries.externalMagnetograms.loading"
          label="Time"
          v-model="myRun.config.coronal_model.Magnetogram.source"
        ></v-select>
      </v-flex>
      <v-flex class="px-3" sm6 v-if="myRun.config.coronal_model.Magnetogram.provider === 'custom'" xs12>
        <v-select
          :item-text="'filename'"
          :item-value="'url'"
          :items="myMagnetograms"
          :loading="$apollo.queries.myMagnetograms.loading || $wait.is('uploading a magnetogram')"
          label="Filename"
          v-model="myRun.config.coronal_model.Magnetogram.source"
        >
          <template v-slot:append>
            <v-icon color="info">arrow_drop_down</v-icon>
            <UploadButton :fileChangedCallback="inputMagnetogramFile" class="mr-0" flat icon small title="Upload new">
              <template slot="icon">
                <v-icon color="info">cloud_upload</v-icon>
              </template>
            </UploadButton>
          </template>
        </v-select>
      </v-flex>
      <v-flex class="px-3" md6 v-show="expertMode" xs12>
        <v-text-field
          :error-messages="errorMessages($v.myRun.config.coronal_model.Magnetogram.degrees_per_pixel)"
          @blur="$v.myRun.config.coronal_model.Magnetogram.degrees_per_pixel.$touch()"
          @input="$v.myRun.config.coronal_model.Magnetogram.degrees_per_pixel.$touch()"
          hint="Resolution of the regridded (Plate Caree) magnetogram"
          label="Resolution"
          suffix="deg/pixel"
          type="number"
          v-model="myRun.config.coronal_model.Magnetogram.degrees_per_pixel"
        ></v-text-field>
      </v-flex>
      <v-flex class="px-3" md6 v-show="expertMode" xs12>
        <v-text-field
          :error-messages="errorMessages($v.myRun.config.coronal_model.Magnetogram.gaussian_smoothing_sd)"
          @blur="$v.myRun.config.coronal_model.Magnetogram.gaussian_smoothing_sd.$touch()"
          @input="$v.myRun.config.coronal_model.Magnetogram.gaussian_smoothing_sd.$touch()"
          hint="Standard deviation of gaussian kernel smoothing"
          label="Smoothing"
          step="0.1"
          type="number"
          v-model="myRun.config.coronal_model.Magnetogram.gaussian_smoothing_sd"
        ></v-text-field>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<style>
.upload-btn {
  margin: 0 !important;
  padding: 0 !important;
}
.v-select__selections {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>

<script>
import { EXTERNAL_MAGNETOGRAMS, MY_MAGNETOGRAMS, UPLOAD_MAGNETOGRAM } from '@/graphql.gql';
import UploadButton from 'vuetify-upload-button';
import runMixin from '@/mixins/run';

export default {
  mixins: [runMixin],
  components: { UploadButton },
  data() {
    return {
      providers: [
        {
          text: 'GONG',
          value: 'GONG',
        },
        {
          text: 'GONG/ADAPT',
          value: 'GONG_ADAPT',
        },
        {
          text: 'Custom',
          value: 'custom',
        },
      ],
      menuDate: false,
      externalMagnetograms: [],
    };
  },
  apollo: {
    externalMagnetograms: {
      query: EXTERNAL_MAGNETOGRAMS,
      variables() {
        return {
          provider: this.myRun.config.coronal_model.Magnetogram.provider,
          date: this.myRun.config.coronal_model.Magnetogram.date,
        };
      },
    },
    myMagnetograms: { query: MY_MAGNETOGRAMS },
  },
  methods: {
    async inputMagnetogramFile(newMagnetogramFile) {
      if (!RegExp('.*.fits.gz').test(newMagnetogramFile.name)) {
        this.$snackbar.show('Invalid magnetogram file. Should be a .fit.gz file.');
        return;
      }
      try {
        this.$wait.start('uploading a magnetogram');
        await this.$apollo.mutate({
          mutation: UPLOAD_MAGNETOGRAM,
          variables: { file: newMagnetogramFile },
          update: (store, { data: { uploadMagnetogram } }) => {
            const data = store.readQuery({ query: MY_MAGNETOGRAMS });
            data.myMagnetograms.unshift(uploadMagnetogram);
            store.writeQuery({ query: MY_MAGNETOGRAMS, data });
            this.myRun.config.coronal_model.Magnetogram.source = uploadMagnetogram.url;
          },
        });
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
        this.$snackbar.show('We could upload your magnetogram. Please, try again.');
      } finally {
        this.$wait.end('uploading a magnetogram');
      }
    },
  },
};
</script>
